// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"342":"90af9454","465":"63a030e2","527":"09aa7d0c","528":"b758f910"}[chunkId] + ".css";
};